import React, { useState, useEffect } from "react";
import { Button, Layout, message, Table, Tabs } from "antd";
import axios from "axios";
import { LoadingOutlined } from "@ant-design/icons";
import ENVIRONMENT from "../../../environments";
import ArtistMainLayout from "../ArtistComponents/ArtistMainLayout";
import AgencyArtistInvite from "./AgencyArtistInvite";
import AgencyInvoices from "../AgencyInvoice/AgencyInvoice";
import AdminMainLayout from "../AdminComponents/AdminMainLayout";

const { Header, Content, Footer } = Layout;

function AgencyDetails(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [agencyArtists, setAgencyArtists] = useState([]);
  const [agencyName, setAgencyName] = useState(null);
  const [inviteAgencyArtist, setInviteAgencyArtist] = useState(false);
  const [viewInvoice, setViewInvoice] = useState(false);
  const [artistUsernames, setArtistUsernames] = useState([]);
  const [isAdminView, setIsAdminView] = useState(false);
  const [agencyBillingRate, setAgencyBillingRate] = useState(0);
  const [agencyBillingType, setAgencyBillingType] = useState('');
  const [assignedWorkData, setAssignedWorkData] = useState([]);
  const [assignedWorkLoading, setAssignedWorkLoading] = useState(false);

  useEffect(() => {
    let currentUser = null;
    let payload = {};
    if (window.location.href.includes("admin_agency_details")) {
      // Admin is viewing the agency page
      payload.agency_id = props.match.params.id;
      setIsAdminView(true);
    } else {
      let currentUser = localStorage.getItem("username");
      payload.agency_admin_username = currentUser;
    }

    setIsLoading(true);
    axios.post(ENVIRONMENT.AGENCY_ARTIST_GET_BATCH, payload).then((res) => {
      let agencyArtists = [];
      let artistUsernames = [];
      if (res["data"]) {
        if(res['data'][0]){
          setAgencyName(res["data"][0]["agency_name"]);
          for (let item of res["data"]) {
            artistUsernames.push(item["username"]);
            if (currentUser && item["username"] == currentUser) {
              item["username"] += " (You)";
            }
            if (item['is_admin']){
              setAgencyBillingRate(item['billing_rate'])
              setAgencyBillingType(item['billing_type'])
            }
            agencyArtists.push(item);
          }
        }
      }
      setAgencyArtists(agencyArtists);
      setArtistUsernames(artistUsernames);
      setIsLoading(false);
    });
  }, []);

  const fetchAssignedWork = async () => {
    
    if (!artistUsernames || artistUsernames.length === 0) {
      return;
    }
    
    setAssignedWorkLoading(true);
    const allAssignedWork = [];

    try {
      // Fetch Products
      const productPayload = {
        "required_fields": [
          "id",
          "name",
          "category",
          "assigned_artist",
          "model_status",
          "last_modified_stamp"
        ],
        "order_by": "last_modified_stamp desc",
        "filter_string": `(model_status__in=[2, -4, 8]&&assigned_artist__in=[${artistUsernames.map(username => `'${username}'`).join(',')}])`
      };

      const productResponse = await axios.post(ENVIRONMENT.LIST_PRODUCT, productPayload);
      if (productResponse.data) {
        productResponse.data.forEach(item => {
          allAssignedWork.push({
            key: `product_${item.id}`,
            id: item.id,
            name: item.name,
            category: item.category,
            assigned_artist: item.assigned_artist,
            model_status: item.model_status,
            model_type: 'Product'
          });
        });
      }

      // Fetch Rooms
      const roomPayload = {
        "required_fields": [
          "room_id",
          "room_name",
          "brand_id",
          "category",
          "assigned_artist",
          "model_status",
          "last_modified_stamp"
        ],
        "order_by": "room_id desc",
        "filter_string": `(model_status__in=[2, -4, 8]&&assigned_artist__in=[${artistUsernames.map(username => `'${username}'`).join(',')}])`
      };

      const roomResponse = await axios.post(ENVIRONMENT.LIST_ROOMS, roomPayload);
      if (roomResponse.data) {
        roomResponse.data.forEach(item => {
          allAssignedWork.push({
            key: `room_${item.room_id}`,
            id: item.room_id,
            name: item.room_name,
            category: item.category,
            assigned_artist: item.assigned_artist,
            model_status: item.model_status,
            model_type: 'Room'
          });
        });
      }

      // Fetch Materials for each artist
      for (const artistUsername of artistUsernames) {
        const materialPayload = {
          "status": "2",
          "assigned_artist": artistUsername
        };

        const materialResponse = await axios.post(ENVIRONMENT.MATERIAL_GET_BATCH, materialPayload);
        if (materialResponse.data && materialResponse.data.body) {
          const materials = JSON.parse(materialResponse.data.body);
          materials.forEach(item => {
            allAssignedWork.push({
              key: `material_${item.id}`,
              id: item.id,
              name: item.name,
              category: item.category,
              assigned_artist: item.assigned_artist,
              model_status: item.status, 
              model_type: 'Material'
            });
          });
        }
      }

      // Sort by ID descending
      allAssignedWork.sort((a, b) => b.id - a.id);
      setAssignedWorkData(allAssignedWork);
    } catch (error) {
      message.error('Failed to fetch assigned work data');
    } finally {
      setAssignedWorkLoading(false);
    }
  };

  useEffect(() => {
    if (artistUsernames && artistUsernames.length > 0) {
      fetchAssignedWork();
    }
  }, [artistUsernames]);

  const deactivateAccount = (username) => {
    let payload = {
      username: username,
    }
    console.log(payload);
    axios.post(ENVIRONMENT.DEACTIVATE_USER,payload)
    .then(res => {
      console.log(res);
      window.location.reload();
    }).catch(err => {
      message.info("Something went wrong while disabling the.")
    })
  }

  const columns = [
    {
      title: "Artist Username",
      key: 1,
      dataIndex: "username",
    },
    {
      title: "Artist Email",
      key: 2,
      dataIndex: "email",
    },
    {
      title: "Role",
      key: 3,
      dataIndex: "is_admin",
      render: (text) => <span>{text ? "Agency Admin" : "Artist"}</span>,
    },
    {
      title: "",
      key: 4,
      dataIndex: "username",
      render: (text) => text!=localStorage.getItem('username') ? <a onClick={()=> deactivateAccount(text)}>Disable Artist Account</a> : '',
    },
  ];

  const getModelStatusText = (status, modelType) => {
    const statusNum = parseInt(status);
    
    switch (statusNum) {
      case 2:
        return 'Assigned';
      case -4:
        return 'Rejected';
      case 8:
        return modelType === 'Material' ? 'N/A' : 'Artist Review';
      default:
        return 'N/A';
    }
  };

  const assignedWorkColumns = [
    {
      title: "ID",
      key: "id",
      dataIndex: "id",
      width: "10%",
    },
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
      width: "33%",
    },
    {
      title: "Model Type",
      key: "model_type",
      dataIndex: "model_type",
      width: "12%",
    },
    {
      title: "Model Status",
      key: "model_status",
      dataIndex: "model_status",
      width: "12%",
      render: (text, record) => getModelStatusText(text, record.model_type),
    },
    {
      title: "Category",
      key: "category",
      dataIndex: "category",
      width: "13%",
    },
    {
      title: "Assigned Artist",
      key: "assigned_artist",
      dataIndex: "assigned_artist",
      width: "20%",
    },
  ];

  return (
    <React.Fragment>
      {isAdminView ? (
        <AdminMainLayout>
          {viewInvoice ? (
            <AgencyInvoices
              agencyBillingRate={agencyBillingRate}
              agencyBillingType={agencyBillingType}
              artistUsernames={artistUsernames}
              setViewInvoice={setViewInvoice}
            />
          ) : (
            <div className="content-container">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20, marginBottom: 20 }}>
                <h3 style={{ margin: 0 }}>
                  Agency Details
                </h3>
                <div style={{ display: "flex", gap: 10 }}>
                  <Button
                    className="modal-okay square font-14"
                    key="view_invoice"
                    onClick={() => setViewInvoice(true)}
                  >
                    View Agency Invoice
                  </Button>
                </div>
              </div>

              <Tabs defaultActiveKey="members">
                <Tabs.TabPane tab="Agency Members" key="members">
                  <Table
                    columns={columns}
                    dataSource={agencyArtists}
                    bordered={true}
                    loading={{
                      indicator: <LoadingOutlined />,
                      spinning: isLoading,
                    }}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Assigned Work" key="work">
                  <Table
                    columns={assignedWorkColumns}
                    dataSource={assignedWorkData}
                    bordered={true}
                    loading={{
                      indicator: <LoadingOutlined />,
                      spinning: assignedWorkLoading,
                    }}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      showQuickJumper: false,
                    }}
                    rowKey="key"
                  />
                </Tabs.TabPane>
              </Tabs>
            </div>
          )}
        </AdminMainLayout>
      ) : (
        <ArtistMainLayout>
          {inviteAgencyArtist ? (
            <AgencyArtistInvite
              agencyName={agencyName}
              setInviteAgencyArtist={setInviteAgencyArtist}
            />
          ) : viewInvoice ? (
            <AgencyInvoices
              agencyBillingRate={agencyBillingRate}
              agencyBillingType={agencyBillingType}
              artistUsernames={artistUsernames}
              setViewInvoice={setViewInvoice}
            />
          ) : (
            <div className="content-container">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20, marginBottom: 20 }}>
                <h3 style={{ margin: 0 }}>
                  Agency Details
                </h3>
                <div style={{ display: "flex", gap: 10 }}>
                  <Button
                    className="modal-okay square font-14"
                    key="invite_user"
                    onClick={() => setInviteAgencyArtist(true)}
                  >
                    Invite New Artist
                  </Button>

                  <Button
                    className="modal-okay square font-14"
                    key="view_invoice"
                    onClick={() => setViewInvoice(true)}
                  >
                    View Agency Invoice
                  </Button>
                </div>
              </div>

              <Tabs defaultActiveKey="members">
                <Tabs.TabPane tab="Agency Members" key="members">
                  <Table
                    columns={columns}
                    dataSource={agencyArtists}
                    bordered={true}
                    loading={{
                      indicator: <LoadingOutlined />,
                      spinning: isLoading,
                    }}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Assigned Work" key="work">
                  <Table
                    columns={assignedWorkColumns}
                    dataSource={assignedWorkData}
                    bordered={true}
                    loading={{
                      indicator: <LoadingOutlined />,
                      spinning: assignedWorkLoading,
                    }}
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: true,
                      showQuickJumper: false,
                    }}
                    rowKey="key"
                  />
                </Tabs.TabPane>
              </Tabs>
            </div>
          )}
        </ArtistMainLayout>
      )}
    </React.Fragment>
  );
}

export default AgencyDetails;
